import { render, staticRenderFns } from "./AuthList.vue?vue&type=template&id=72447882"
import script from "./AuthList.vue?vue&type=script&lang=js"
export * from "./AuthList.vue?vue&type=script&lang=js"
import style0 from "./AuthList.vue?vue&type=style&index=0&id=72447882&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports